/* Auto-generated from Next data/products.json — do not edit */
window.TBP_GALLERY = 
{
  "ODB|Black": [
    {
      "jpg": "tbp-m-odb-black-1.jpg",
      "webp": "tbp-m-odb-black-1.webp"
    },
    {
      "jpg": "tbp-m-odb-black-2.jpg",
      "webp": "tbp-m-odb-black-2.webp"
    },
    {
      "jpg": "tbp-l-odb-black1.jpg",
      "webp": "tbp-l-odb-black1.webp"
    }
  ],
  "ODB|Charcoal": [
    {
      "jpg": "tbp-m-odb-charcoal-1.jpg",
      "webp": "tbp-m-odb-charcoal-1.webp"
    },
    {
      "jpg": "tbp-m-odb-charcoal-2.jpg",
      "webp": "tbp-m-odb-charcoal-2.webp"
    },
    {
      "jpg": "tbp-l-odb-charcoal.jpg",
      "webp": "tbp-l-odb-charcoal.webp"
    }
  ],
  "ODB|Beige": [
    {
      "jpg": "tbp-m-odb-beige-1.jpg",
      "webp": "tbp-m-odb-beige-1.webp"
    },
    {
      "jpg": "tbp-m-odb-beige-2.jpg",
      "webp": "tbp-m-odb-beige-2.webp"
    },
    {
      "jpg": "tbp-l-odb-beige1.jpg",
      "webp": "tbp-l-odb-beige1.webp"
    }
  ],
  "ODB|Mocha": [
    {
      "jpg": "tbp-m-odb-mocha-1.jpg",
      "webp": "tbp-m-odb-mocha-1.webp"
    },
    {
      "jpg": "tbp-m-odb-mocha-2.jpg",
      "webp": "tbp-m-odb-mocha-2.webp"
    },
    {
      "jpg": "tbp-l-odb-mocha1.jpg",
      "webp": "tbp-l-odb-mocha1.webp"
    }
  ],
  "ODB|Red": [
    {
      "jpg": "tbp-m-odb-red-1.jpg",
      "webp": "tbp-m-odb-red-1.webp"
    },
    {
      "jpg": "tbp-m-odb-red-2.jpg",
      "webp": "tbp-m-odb-red-2.webp"
    },
    {
      "jpg": "tbp-l-odb-red1.jpg",
      "webp": "tbp-l-odb-red1.webp"
    }
  ],
  "ODB|Aqua": [
    {
      "jpg": "tbp-m-odb-aqua-1.jpg",
      "webp": "tbp-m-odb-aqua-1.webp"
    },
    {
      "jpg": "tbp-m-odb-aqua-2.jpg",
      "webp": "tbp-m-odb-aqua-2.webp"
    },
    {
      "jpg": "tbp-l-odb-aqua1.jpg",
      "webp": "tbp-l-odb-aqua1.webp"
    }
  ],
  "ODB|Green": [
    {
      "jpg": "tbp-m-odb-green-1.jpg",
      "webp": "tbp-m-odb-green-1.webp"
    },
    {
      "jpg": "tbp-m-odb-green-2.jpg",
      "webp": "tbp-m-odb-green-2.webp"
    },
    {
      "jpg": "tbp-l-odb-green.jpg",
      "webp": "tbp-l-odb-green.webp"
    }
  ],
  "ODB|White": [
    {
      "jpg": "tbp-m-odb-white-1.jpg",
      "webp": "tbp-m-odb-white-1.webp"
    },
    {
      "jpg": "tbp-m-odb-white-2.jpg",
      "webp": "tbp-m-odb-white-2.webp"
    },
    {
      "jpg": "tbp-l-odb-white.jpg",
      "webp": "tbp-l-odb-white.webp"
    }
  ],
  "ODB|Jeans": [
    {
      "jpg": "tbp-m-odb-jeans-1.jpg",
      "webp": "tbp-m-odb-jeans-1.webp"
    },
    {
      "jpg": "tbp-m-odb-jeans-2.jpg",
      "webp": "tbp-m-odb-jeans-2.webp"
    },
    {
      "jpg": "tbp-l-odb-jeans1.jpg",
      "webp": "tbp-l-odb-jeans1.webp"
    }
  ],
  "ODB|Cosmic": [
    {
      "jpg": "tbp-m-odb-cosmic-1.jpg",
      "webp": "tbp-m-odb-cosmic-1.webp"
    },
    {
      "jpg": "tbp-m-odb-cosmic-2.jpg",
      "webp": "tbp-m-odb-cosmic-2.webp"
    },
    {
      "jpg": "tbp-l-odb-cosmic1.jpg",
      "webp": "tbp-l-odb-cosmic1.webp"
    }
  ],
  "ODB|Camo": [
    {
      "jpg": "tbp-m-odb-camo-1.jpg",
      "webp": "tbp-m-odb-camo-1.webp"
    },
    {
      "jpg": "tbp-m-odb-camo-2.jpg",
      "webp": "tbp-m-odb-camo-2.webp"
    },
    {
      "jpg": "tbp-l-odb-camo1.jpg",
      "webp": "tbp-l-odb-camo1.webp"
    }
  ],
  "ODB|Nirvana": [
    {
      "jpg": "tbp-m-odb-nirvana-1.jpg",
      "webp": "tbp-m-odb-nirvana-1.webp"
    },
    {
      "jpg": "tbp-m-odb-nirvana-2.jpg",
      "webp": "tbp-m-odb-nirvana-2.webp"
    },
    {
      "jpg": "tbp-l-odb-nirvana1.jpg",
      "webp": "tbp-l-odb-nirvana1.webp"
    }
  ],
  "ODB|Metropolis": [
    {
      "jpg": "tbp-m-odb-metropolis-1.jpg",
      "webp": "tbp-m-odb-metropolis-1.webp"
    },
    {
      "jpg": "tbp-m-odb-metropolis-2.jpg",
      "webp": "tbp-m-odb-metropolis-2.webp"
    },
    {
      "jpg": "tbp-l-odb-metropolis.jpg",
      "webp": "tbp-l-odb-metropolis.webp"
    }
  ],
  "ODB|Deep Sea": [
    {
      "jpg": "tbp-m-odb-deep-sea-1.jpg",
      "webp": "tbp-m-odb-deep-sea-1.webp"
    },
    {
      "jpg": "tbp-m-odb-deep-sea-2.jpg",
      "webp": "tbp-m-odb-deep-sea-2.webp"
    },
    {
      "jpg": "tbp-l-odb-deep-sea.jpg",
      "webp": "tbp-l-odb-deep-sea.webp"
    }
  ],
  "OMG|Beige": [
    {
      "jpg": "tbp-m-omg-beige-1.jpg",
      "webp": "tbp-m-omg-beige-1.webp"
    },
    {
      "jpg": "tbp-m-omg-beige-2.jpg",
      "webp": "tbp-m-omg-beige-2.webp"
    },
    {
      "jpg": "tbp-l-omg-beige1.jpg",
      "webp": "tbp-l-omg-beige1.webp"
    }
  ],
  "OMG|Black": [
    {
      "jpg": "tbp-m-omg-black-1.jpg",
      "webp": "tbp-m-omg-black-1.webp"
    },
    {
      "jpg": "tbp-m-omg-black-2.jpg",
      "webp": "tbp-m-omg-black-2.webp"
    },
    {
      "jpg": "tbp-l-omg-black1.jpg",
      "webp": "tbp-l-omg-black1.webp"
    }
  ],
  "OMG|Charcoal": [
    {
      "jpg": "tbp-m-omg-charcoal-1.jpg",
      "webp": "tbp-m-omg-charcoal-1.webp"
    },
    {
      "jpg": "tbp-m-omg-charcoal-2.jpg",
      "webp": "tbp-m-omg-charcoal-2.webp"
    },
    {
      "jpg": "tbp-l-omg-charcoal2.jpg",
      "webp": "tbp-l-omg-charcoal2.webp"
    }
  ],
  "OMG|Mocha": [
    {
      "jpg": "tbp-m-omg-mocha-1.jpg",
      "webp": "tbp-m-omg-mocha-1.webp"
    },
    {
      "jpg": "tbp-m-omg-mocha-2.jpg",
      "webp": "tbp-m-omg-mocha-2.webp"
    },
    {
      "jpg": "tbp-l-omg-mocha1.jpg",
      "webp": "tbp-l-omg-mocha1.webp"
    }
  ],
  "OMG|Red": [
    {
      "jpg": "tbp-m-omg-red-1.jpg",
      "webp": "tbp-m-omg-red-1.webp"
    },
    {
      "jpg": "tbp-m-omg-red-2.jpg",
      "webp": "tbp-m-omg-red-2.webp"
    },
    {
      "jpg": "tbp-l-omg-red.jpg",
      "webp": "tbp-l-omg-red.webp"
    }
  ],
  "OMG|Aqua": [
    {
      "jpg": "tbp-m-omg-aqua-1.jpg",
      "webp": "tbp-m-omg-aqua-1.webp"
    },
    {
      "jpg": "tbp-m-omg-aqua-2.jpg",
      "webp": "tbp-m-omg-aqua-2.webp"
    },
    {
      "jpg": "tbp-l-omg-aqua.jpg",
      "webp": "tbp-l-omg-aqua.webp"
    }
  ],
  "OMG|Green": [
    {
      "jpg": "tbp-m-omg-green-1.jpg",
      "webp": "tbp-m-omg-green-1.webp"
    },
    {
      "jpg": "tbp-m-omg-green-2.jpg",
      "webp": "tbp-m-omg-green-2.webp"
    },
    {
      "jpg": "tbp-l-omg-green.jpg",
      "webp": "tbp-l-omg-green.webp"
    }
  ],
  "OMG|Purple": [
    {
      "jpg": "tbp-m-omg-purple-1.jpg",
      "webp": "tbp-m-omg-purple-1.webp"
    },
    {
      "jpg": "tbp-m-omg-purple-2.jpg",
      "webp": "tbp-m-omg-purple-2.webp"
    },
    {
      "jpg": "tbp-l-omg-purple.jpg",
      "webp": "tbp-l-omg-purple.webp"
    }
  ],
  "OMG|Jeans": [
    {
      "jpg": "tbp-m-omg-jeans-1.jpg",
      "webp": "tbp-m-omg-jeans-1.webp"
    },
    {
      "jpg": "tbp-m-omg-jeans-2.jpg",
      "webp": "tbp-m-omg-jeans-2.webp"
    },
    {
      "jpg": "tbp-l-omg-jeans1.jpg",
      "webp": "tbp-l-omg-jeans1.webp"
    }
  ],
  "OMG|Cosmic": [
    {
      "jpg": "tbp-m-omg-cosmic-1.jpg",
      "webp": "tbp-m-omg-cosmic-1.webp"
    },
    {
      "jpg": "tbp-m-omg-cosmic-2.jpg",
      "webp": "tbp-m-omg-cosmic-2.webp"
    },
    {
      "jpg": "tbp-l-omg-cosmic1.jpg",
      "webp": "tbp-l-omg-cosmic1.webp"
    }
  ],
  "OMG|Camo": [
    {
      "jpg": "tbp-m-omg-camo-1.jpg",
      "webp": "tbp-m-omg-camo-1.webp"
    },
    {
      "jpg": "tbp-m-omg-camo-2.jpg",
      "webp": "tbp-m-omg-camo-2.webp"
    },
    {
      "jpg": "tbp-l-omg-camo.jpg",
      "webp": "tbp-l-omg-camo.webp"
    }
  ],
  "OMG|Nirvana": [
    {
      "jpg": "tbp-m-omg-nirvana-1.jpg",
      "webp": "tbp-m-omg-nirvana-1.webp"
    },
    {
      "jpg": "tbp-m-omg-nirvana-2.jpg",
      "webp": "tbp-m-omg-nirvana-2.webp"
    },
    {
      "jpg": "tbp-l-omg-nirvana1.jpg",
      "webp": "tbp-l-omg-nirvana1.webp"
    }
  ],
  "OMG|Booty Beach": [
    {
      "jpg": "tbp-m-omg-booty-beach-1.jpg",
      "webp": "tbp-m-omg-booty-beach-1.webp"
    },
    {
      "jpg": "tbp-m-omg-booty-beach-2.jpg",
      "webp": "tbp-m-omg-booty-beach-2.webp"
    },
    {
      "jpg": "tbp-l-omg-booty-beach-5.jpg",
      "webp": "tbp-l-omg-booty-beach-5.webp"
    }
  ],
  "ORT|Beige": [
    {
      "jpg": "tbp-m-ort-beige-1.jpg",
      "webp": "tbp-m-ort-beige-1.webp"
    },
    {
      "jpg": "tbp-m-ort-beige-2.jpg",
      "webp": "tbp-m-ort-beige-2.webp"
    },
    {
      "jpg": "tbp-l-ort-beige-main.jpg",
      "webp": "tbp-l-ort-beige-main.webp"
    }
  ],
  "ORT|Charcoal": [
    {
      "jpg": "tbp-m-ort-charcoal-1.jpg",
      "webp": "tbp-m-ort-charcoal-1.webp"
    },
    {
      "jpg": "tbp-m-ort-charcoal-2.jpg",
      "webp": "tbp-m-ort-charcoal-2.webp"
    },
    {
      "jpg": "tbp-l-ort-charcoal.jpg",
      "webp": "tbp-l-ort-charcoal.webp"
    }
  ],
  "ORT|Black": [
    {
      "jpg": "tbp-m-ort-black-1.jpg",
      "webp": "tbp-m-ort-black-1.webp"
    },
    {
      "jpg": "tbp-m-ort-black-2.jpg",
      "webp": "tbp-m-ort-black-2.webp"
    },
    {
      "jpg": "tbp-l-ort-black.jpg",
      "webp": "tbp-l-ort-black.webp"
    }
  ],
  "ORT|Mocha": [
    {
      "jpg": "tbp-m-ort-mocha-1.jpg",
      "webp": "tbp-m-ort-mocha-1.webp"
    },
    {
      "jpg": "tbp-m-ort-mocha-2.jpg",
      "webp": "tbp-m-ort-mocha-2.webp"
    },
    {
      "jpg": "tbp-l-ort-mocha1.jpg",
      "webp": "tbp-l-ort-mocha1.webp"
    }
  ],
  "ORT|Red": [
    {
      "jpg": "tbp-m-ort-red-1.jpg",
      "webp": "tbp-m-ort-red-1.webp"
    },
    {
      "jpg": "tbp-m-ort-red-2.jpg",
      "webp": "tbp-m-ort-red-2.webp"
    },
    {
      "jpg": "tbp-l-ort-red1.jpg",
      "webp": "tbp-l-ort-red1.webp"
    }
  ],
  "ORT|Aqua": [
    {
      "jpg": "tbp-m-ort-aqua-1.jpg",
      "webp": "tbp-m-ort-aqua-1.webp"
    },
    {
      "jpg": "tbp-m-ort-aqua-2.jpg",
      "webp": "tbp-m-ort-aqua-2.webp"
    },
    {
      "jpg": "tbp-l-ort-aqua1.jpg",
      "webp": "tbp-l-ort-aqua1.webp"
    }
  ],
  "ORT|Green": [
    {
      "jpg": "tbp-m-ort-green-1.jpg",
      "webp": "tbp-m-ort-green-1.webp"
    },
    {
      "jpg": "tbp-m-ort-green-2.jpg",
      "webp": "tbp-m-ort-green-2.webp"
    },
    {
      "jpg": "tbp-l-ort-green1.jpg",
      "webp": "tbp-l-ort-green1.webp"
    }
  ],
  "ORT|Jeans": [
    {
      "jpg": "tbp-m-ort-jeans-1.jpg",
      "webp": "tbp-m-ort-jeans-1.webp"
    },
    {
      "jpg": "tbp-m-ort-jeans-2.jpg",
      "webp": "tbp-m-ort-jeans-2.webp"
    },
    {
      "jpg": "tbp-l-ort-jeans1.jpg",
      "webp": "tbp-l-ort-jeans1.webp"
    }
  ],
  "ORT|Cosmic": [
    {
      "jpg": "tbp-m-ort-cosmic-1.jpg",
      "webp": "tbp-m-ort-cosmic-1.webp"
    },
    {
      "jpg": "tbp-m-ort-cosmic-2.jpg",
      "webp": "tbp-m-ort-cosmic-2.webp"
    },
    {
      "jpg": "tbp-l-ort-cosmic1.jpg",
      "webp": "tbp-l-ort-cosmic1.webp"
    }
  ],
  "ORT|Camo": [
    {
      "jpg": "tbp-m-ort-camo-1.jpg",
      "webp": "tbp-m-ort-camo-1.webp"
    },
    {
      "jpg": "tbp-m-ort-camo-2.jpg",
      "webp": "tbp-m-ort-camo-2.webp"
    },
    {
      "jpg": "tbp-l-ort-camo1.jpg",
      "webp": "tbp-l-ort-camo1.webp"
    }
  ],
  "ORT|Nirvana": [
    {
      "jpg": "tbp-m-ort-nirvana-1.jpg",
      "webp": "tbp-m-ort-nirvana-1.webp"
    },
    {
      "jpg": "tbp-m-ort-nirvana-2.jpg",
      "webp": "tbp-m-ort-nirvana-2.webp"
    },
    {
      "jpg": "tbp-l-ort-beige-and-nirvana.jpg",
      "webp": "tbp-l-ort-beige-and-nirvana.webp"
    }
  ]
};

window.TBP_SWATCHES = {
  "ODB|Black": "tbp-s-odb-black.jpg",
  "ODB|Charcoal": "tbp-s-odb-charcoal.jpg",
  "ODB|Beige": "tbp-s-odb-beige.jpg",
  "ODB|Mocha": "tbp-s-odb-mocha.jpg",
  "ODB|Red": "tbp-s-odb-red.jpg",
  "ODB|Aqua": "tbp-s-odb-aqua.jpg",
  "ODB|Green": "tbp-s-odb-green.jpg",
  "ODB|White": "tbp-s-odb-white.jpg",
  "ODB|Jeans": "tbp-s-odb-jeans.jpg",
  "ODB|Cosmic": "tbp-s-odb-cosmic.jpg",
  "ODB|Camo": "tbp-s-odb-camo.jpg",
  "ODB|Nirvana": "tbp-s-odb-nirvana.jpg",
  "ODB|Metropolis": "tbp-s-odb-metropolis.jpg",
  "ODB|Deep Sea": "tbp-s-odb-deep-sea.jpg",
  "OMG|Beige": "tbp-s-omg-beige.jpg",
  "OMG|Black": "tbp-s-omg-black.jpg",
  "OMG|Charcoal": "tbp-s-omg-charcoal.jpg",
  "OMG|Mocha": "tbp-s-omg-mocha.jpg",
  "OMG|Red": "tbp-s-omg-red.jpg",
  "OMG|Aqua": "tbp-s-omg-aqua.jpg",
  "OMG|Green": "tbp-s-omg-green.jpg",
  "OMG|Purple": "tbp-s-omg-purple.jpg",
  "OMG|Jeans": "tbp-s-omg-jeans.jpg",
  "OMG|Cosmic": "tbp-s-omg-cosmic.jpg",
  "OMG|Camo": "tbp-s-omg-camo.jpg",
  "OMG|Nirvana": "tbp-s-omg-nirvana.jpg",
  "OMG|Booty Beach": "tbp-s-omg-booty-beach.jpg",
  "ORT|Beige": "tbp-s-ort-beige.jpg",
  "ORT|Charcoal": "tbp-s-ort-charcoal.jpg",
  "ORT|Black": "tbp-s-ort-black.jpg",
  "ORT|Mocha": "tbp-s-ort-mocha.jpg",
  "ORT|Red": "tbp-s-ort-red.jpg",
  "ORT|Aqua": "tbp-s-ort-aqua.jpg",
  "ORT|Green": "tbp-s-ort-green.jpg",
  "ORT|Jeans": "tbp-s-ort-jeans.jpg",
  "ORT|Cosmic": "tbp-s-ort-cosmic.jpg",
  "ORT|Camo": "tbp-s-ort-camo.jpg",
  "ORT|Nirvana": "tbp-s-ort-nirvana.jpg"
};
